/** @jsxImportSource @emotion/react */

import { FC } from 'react'
import Typography from '@mui/material/Typography'
import { findAllUsers_findAllUsers_items_purchases as Purchases } from '__generatedTypes__/findAllUsers'
import * as classes from './styles'

export type PurchaseKey = keyof Purchases

type Props = {
  purchases: Purchases
  title: string
  type: PurchaseKey
}

export const TooltipTitle: FC<Props> = ({ purchases, title, type }) => {
  const purchaseTitles = purchases?.[type] as string[]

  return (
    <div>
      <Typography variant="body1" css={classes.title}>
        {title}
      </Typography>
      <div css={classes.purchases}>
        {purchaseTitles
          ? purchaseTitles.map((purchase) => (
              <Typography key={purchase} variant="body1" css={classes.purchaseTitle}>
                {purchase}
              </Typography>
            ))
          : '-'}
      </div>
    </div>
  )
}
